<template>
  <div class="fill-height pa-4 d-flex align-center justify-center">
    <div>
      <CheckMark
        class="mx-auto"
        style="width: 200px; height: 200px"
      />
      <div class="py-8 text-h2 font-weight-light text-center">
        Congratulations!<br>
        All done!
      </div>
      <v-alert
        v-if="suggestedLegalCaseTypes.length"
        type="info"
      >
        <p>You have suggested the creation of the following Legal Cases:</p>
        <div class="d-flex">
          <ul>
            <li
              v-for="(legalCaseType, index) of suggestedLegalCaseTypes"
              :key="index"
            >
              {{ legalCaseType }}
            </li>
          </ul>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                class="ml-12 mr-4"
                icon
                outlined
                v-bind="attrs"
                v-on="on"
                @click="copyToClipboard(suggestedLegalCaseTypesText, 'Suggested Legal Cases')"
              >
                <v-icon>mdi-clipboard-text</v-icon>
              </v-btn>
            </template>
            <span>Copy to Clipboard</span>
          </v-tooltip>
        </div>
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'
import { copyToClipboard } from '@/utilities/clipboard'

import { QUICK_INTERVIEW_NAMESPACE } from '@/store/quick-interview'

import CheckMark from '@/components/Icons/CheckMark.vue'

export default {
  name: 'InterviewSummaryStep',

  components: {
    CheckMark,
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  computed: {
    suggestedLegalCaseTypes () {
      return this.quickInterview.
        steps_data.
        find(step => step.component === 'SuggestLegalCasesStep')?.
        data?.
        suggested_legal_case_types || []
    },

    suggestedLegalCaseTypesText () {
      return '\n- ' + this.suggestedLegalCaseTypes.join('\n- ')
    },

    ...mapGetters(QUICK_INTERVIEW_NAMESPACE, [
      'quickInterview',
    ]),
  },

  created () {
    this.$emit('changed', true)
  },

  methods: {

    copyToClipboard (text, description) {
      copyToClipboard(this.displayAlert, text, description)
    },
  },
}
</script>
